<template>
  <div class="yt-wp bg">
    <div class="live-prepare">
      <div class="title">
        <span>设备检测</span>
      </div>
      <table width="100%" border="1" bordercolor="#ededed" cellspacing="0">
        <tbody>
          <tr cellpadding="20">
            <td width="12%"></td>
            <td width="44%">Windows计算机需求</td>
            <td width="44%">mac计算机需求</td>
          </tr>
          <tr>
            <td>CPU</td>
            <td>Intel 酷睿i3或更快的处理器</td>
            <td>Intel 酷睿M或更快的处理器</td>
          </tr>
          <tr>
            <td>操作系统</td>
            <td>微软Windows 7操作系统或更高的版本</td>
            <td>macOS 10.10或更高的版本</td>
          </tr>
          <tr>
            <td>内存</td>
            <td>2G以上的内存</td>
            <td>4G以上的内存</td>
          </tr>
          <tr>
            <td>显示器</td>
            <td>至少1280x800分辨率的显示器</td>
            <td>至少1280x800分辨率的显示器</td>
          </tr>
          <tr>
            <td>浏览器</td>
            <td>推荐使用QQ浏览器、360极速浏览器或Google Chrome浏览器</td>
            <td>推荐使用QQ浏览器、360极速浏览器或Google Chrome浏览器</td>
          </tr>
          <tr>
            <td>其他设备</td>
            <td>摄像头、麦克风、扬声器/耳机</td>
            <td>摄像头、麦克风、扬声器/耳机</td>
          </tr>
        </tbody>
      </table>
      <p class="tips">为确保网络授课能正常进行，计算机建议满足以上配置需求。建议以有线光纤宽带连接网络（如10M/1280Kbps），尽可能避免使用移动网络或无线网络。若依然有任何操作上的问题，请致电<span class="f-c-red">027-87223199</span>，我们将有专人为您服务。</p>
      <div class="prepare-btn-box">
        <a href="check.html#/" class="prepare-btn">开始设备检测</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'prepare',
  data () {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  mounted () {
    this.$store.getters.setHistoryBack(this.$route.query.back)
  }
};
</script>

<style scoped>
  .yt-wp {
    background: url(../../assets/img/bg.jpg)
  }
  .f-c-red {
    color: #ea3c32
  }
</style>